import { AccordionDetails, AccordionSummary, Accordion } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { H5 } from '../../themes/typography';

const layoutImg =
    'https://images.unsplash.com/photo-1751554827598-c96cb294c0e6?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D';

export default function Layout({ layoutUrl = layoutImg }) {
    return (
        <div className="event-preview-layout-container">
            <Accordion
                sx={{
                    alignSelf: 'stretch',
                    fontWeight: 700,
                    background: 'var(--gradient-blue)',
                    color: 'var(--quaternary-color)',
                    borderRadius: '1rem !important',
                    boxShadow: 'none',
                    textAlign: 'justify',
                    '& .MuiAccordionSummary-root': {
                        minHeight: '56px'
                    },
                    '& .MuiAccordionSummary-expandIconWrapper': {
                        color: 'var(--quaternary-color)'
                    }
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <H5 fontWeight={700}>Event Layout</H5>
                </AccordionSummary>
                <AccordionDetails>
                    <div className="event-preview-layout-img">
                        <img src={layoutUrl} alt="Event Layout" />
                    </div>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}
